'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.series = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _filter2 = require('lodash/filter');
var _filter3 = _interopRequireDefault(_filter2);
var _isNil2 = require('lodash/isNil');
var _isNil3 = _interopRequireDefault(_isNil2);
var _keys2 = require('lodash/keys');
var _keys3 = _interopRequireDefault(_keys2);
var _find2 = require('lodash/find');
var _find3 = _interopRequireDefault(_find2);
var _has2 = require('lodash/has');
var _has3 = _interopRequireDefault(_has2);
var _includes2 = require('lodash/includes');
var _includes3 = _interopRequireDefault(_includes2);
var _split2 = require('lodash/split');
var _split3 = _interopRequireDefault(_split2);
var _findIndex2 = require('lodash/findIndex');
var _findIndex3 = _interopRequireDefault(_findIndex2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _reduce2 = require('lodash/reduce');
var _reduce3 = _interopRequireDefault(_reduce2);
var _map2 = require('lodash/map');
var _map3 = _interopRequireDefault(_map2);
var _reject2 = require('lodash/reject');
var _reject3 = _interopRequireDefault(_reject2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
exports.dimensionValueIsValid = dimensionValueIsValid;
exports.getDimensionValues = getDimensionValues;
exports.getDimensionValueKey = getDimensionValueKey;
exports.datapoints = datapoints;
var _dimensionUtils = require('../dimension-utils');
var _observationFormater = require('../observation-formater');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function dimensionValueIsValid(dimensionValue, chartDimension) {
  return (0, _includes3.default)((0, _map3.default)(['x', 'y'], function (k) {
    return (0, _get3.default)(chartDimension, k + 'Id');
  }), (0, _get3.default)(dimensionValue, 'id'));
}
;
function getDimensionValues(dimensionValuesIndexes, dimensions, dimensionsWithValuesIndexedById, chartDimensionId, display) {
  var dimensionsWithValuesIds = (0, _keys3.default)(dimensionsWithValuesIndexedById);
  return (0, _reduce3.default)(dimensionValuesIndexes, function (m, dvi, i) {
    var dimension = (0, _get3.default)(dimensions, '[' + i + ']');
    var dimensionId = (0, _get3.default)(dimension, 'id');
    var dimensionValue = (0, _get3.default)(dimension, 'values[' + dvi + ']');
    if (dimensionId !== chartDimensionId && (0, _includes3.default)(dimensionsWithValuesIds, dimensionId)) {
      m[dimensionId] = (0, _extends3.default)({}, dimensionValue, {
        name: (0, _dimensionUtils.dimensionValueDisplay)(display)(dimensionValue)
      });
    }
    return m;
  }, {});
}
;
function getDimensionValueKey(chartDimension, dimensionValue) {
  return (0, _get3.default)(chartDimension, 'xId') === (0, _get3.default)(dimensionValue, 'id') ? 'x' : 'y';
}
;
function datapoints(observations, dimensions, dimensionsWithValuesIndexedById, chartDimension, display, formaterAttrs) {
  var chartDimensionId = (0, _get3.default)(chartDimension, 'id');
  var chartDimensionIndex = (0, _findIndex3.default)(dimensions, {
    id: chartDimensionId
  });
  var datapoints = (0, _reduce3.default)(observations, function (m, o, k) {
    var oDimensionValuesIndexes = (0, _split3.default)(k, ':');
    var oDimensionValueIndex = oDimensionValuesIndexes[chartDimensionIndex];
    var oDimensionValue = (0, _get3.default)(dimensions, '[' + chartDimensionIndex + '].values[' + oDimensionValueIndex + ']');
    if (dimensionValueIsValid(oDimensionValue, chartDimension)) {
      var oPartialKey = (0, _reject3.default)(oDimensionValuesIndexes, function (o, i) {
        return i === chartDimensionIndex;
      }).join('');
      if (!(0, _has3.default)(m, oPartialKey)) {
        var dimensionValues = getDimensionValues(oDimensionValuesIndexes, dimensions, dimensionsWithValuesIndexedById, chartDimensionId, display);
        m[oPartialKey] = {
          dimensionValues: dimensionValues
        };
      }
      var dimensionValueKey = getDimensionValueKey(chartDimension, oDimensionValue);
      m[oPartialKey][dimensionValueKey] = (0, _head3.default)(o);
      m[oPartialKey][dimensionValueKey + 'Format'] = (0, _observationFormater.getFormatedObservation)(o, formaterAttrs);
    }
    return m;
  }, {});
  // it is possible to have null observations or incomplete datapoints (just an x or y)
  return (0, _filter3.default)(datapoints, function (dp) {
    return !(0, _isNil3.default)(dp.x) && !(0, _isNil3.default)(dp.y);
  });
}
;
var series = exports.series = function series(observations, dimensions, dimensionsWithValuesIndexedById, chartDimension, display, formaterAttrs) {
  // the 2 following lines may sound absurd but we could have 2 dimensions involved
  // and not only 1 as first specified...
  var xValues = (0, _get3.default)(dimensionsWithValuesIndexedById, (0, _get3.default)(chartDimension, 'id') + '.values', []);
  var yValues = (0, _get3.default)(dimensionsWithValuesIndexedById, (0, _get3.default)(chartDimension, 'id') + '.values', []);
  var xValue = (0, _find3.default)(xValues, {
    id: (0, _get3.default)(chartDimension, 'xId')
  });
  var yValue = (0, _find3.default)(yValues, {
    id: (0, _get3.default)(chartDimension, 'yId')
  });
  return [{
    dimensionValues: {
      x: (0, _extends3.default)({}, xValue, {
        name: (0, _dimensionUtils.dimensionValueDisplay)(display)(xValue)
      }),
      y: (0, _extends3.default)({}, yValue, {
        name: (0, _dimensionUtils.dimensionValueDisplay)(display)(yValue)
      })
    },
    datapoints: datapoints(observations, dimensions, dimensionsWithValuesIndexedById, chartDimension, display, formaterAttrs)
  }];
};
exports.default = function (_ref, dimensionsWithValuesIndexedById, chartDimension, display, formaterAttrs) {
  var observations = _ref.observations,
    dimensions = _ref.dimensions;
  return series(observations, dimensions, dimensionsWithValuesIndexedById, chartDimension, display, formaterAttrs);
};